/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UserCreateRequest,
  UserRepresentation,
  UserUpdateRequest,
} from '../models/index';
import {
    UserCreateRequestFromJSON,
    UserCreateRequestToJSON,
    UserRepresentationFromJSON,
    UserRepresentationToJSON,
    UserUpdateRequestFromJSON,
    UserUpdateRequestToJSON,
} from '../models/index';

export interface CreateUserRequest {
    userCreateRequest: UserCreateRequest;
}

export interface DeleteUserRequest {
    key: string;
}

export interface GetUserRequest {
    key: string;
}

export interface GetUsersRequest {
    companyKey?: string;
}

export interface UpdateUserRequest {
    key: string;
    userUpdateRequest?: UserUpdateRequest;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Create a new user for the specified company
     * Create a new user
     */
    async createUserRaw(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRepresentation>> {
        if (requestParameters['userCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'userCreateRequest',
                'Required parameter "userCreateRequest" was null or undefined when calling createUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["users:manage"]);
        }


        let urlPath = `/users`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateRequestToJSON(requestParameters['userCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new user for the specified company
     * Create a new user
     */
    async createUser(userCreateRequest: UserCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRepresentation> {
        const response = await this.createUserRaw({ userCreateRequest: userCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete the user
     * Delete the user
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["users:manage"]);
        }


        let urlPath = `/users/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the user
     * Delete the user
     */
    async deleteUser(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw({ key: key }, initOverrides);
    }

    /**
     * Return the user with the specified id
     * Return user
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["users:read"]);
        }


        let urlPath = `/users/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRepresentationFromJSON(jsonValue));
    }

    /**
     * Return the user with the specified id
     * Return user
     */
    async getUser(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRepresentation> {
        const response = await this.getUserRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Return all users
     * Return all users
     */
    async getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['companyKey'] != null) {
            queryParameters['companyKey'] = requestParameters['companyKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["users:read"]);
        }


        let urlPath = `/users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserRepresentationFromJSON));
    }

    /**
     * Return all users
     * Return all users
     */
    async getUsers(companyKey?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserRepresentation>> {
        const response = await this.getUsersRaw({ companyKey: companyKey }, initOverrides);
        return await response.value();
    }

    /**
     * Update the user
     * Update the user
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["users:manage"]);
        }


        let urlPath = `/users/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateRequestToJSON(requestParameters['userUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRepresentationFromJSON(jsonValue));
    }

    /**
     * Update the user
     * Update the user
     */
    async updateUser(key: string, userUpdateRequest?: UserUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRepresentation> {
        const response = await this.updateUserRaw({ key: key, userUpdateRequest: userUpdateRequest }, initOverrides);
        return await response.value();
    }

}
